// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../fetch.pb.js";
/**
 * =================================== Enum definitions ===================================
 *
 * Enum to represent the type of settings
 */
export var SettingTypes;
(function (SettingTypes) {
    SettingTypes["UNKNOWN"] = "UNKNOWN";
})(SettingTypes || (SettingTypes = {}));
export var SettingTypes_index;
(function (SettingTypes_index) {
    SettingTypes_index[SettingTypes_index["UNKNOWN"] = 0] = "UNKNOWN";
})(SettingTypes_index || (SettingTypes_index = {}));
/**
 * =================================== API Contracts ===================================
 */
export const UserPreferencesAPI = {
    /**
     * GetUserPreferences : get the user preferences settings
     */
    GetUserPreferences(fn, req) {
        return fn(`/user-preferences/settings?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * UpdateUserPreferences : update the user preferences settings
     */
    UpdateUserPreferences(fn, req) {
        return fn(`/user-preferences/settings`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
};
